import { getAuthorizationSessionHeader } from 'api/utils/getAuthorizationSessionHeader'
import axios from 'axios'
import config from 'config'

import { defaultLosJsonHeaders } from '../requestHeaders'

export type FlagFormat = {
    flags: Record<string, { is_active: boolean }>
    switches: Record<string, { is_active: boolean }>
}

export const FEATURE_FLAGS_SWR_KEY = 'feature_flags/waffle_status'

export default async function getCurrentFeatureFlags() {
    try {
        const flags = await axios.get(
            `${config.API_BASE_URL}/feature_flags/waffle_status`,
            {
                withCredentials: true,
                headers: {
                    Authorization: getAuthorizationSessionHeader(),
                    ...defaultLosJsonHeaders(),
                },
            },
        )

        return flags.data as FlagFormat
    } catch {
        return { flags: {}, switches: {} } as FlagFormat
    }
}
